module.exports = __webpack_public_path__ + "img/news_facebook_page.2baf9819.png";